import React from "react";
import { Link } from "react-router-dom";

import Modal from "../../atoms/Modal";
import qrStudentHomepage from "../../assets/images/qr_student_homepage.png";
import { studentTemporaryPasswordListPath } from "../../teacherStore";

import styles from "./StudentLoginQrCodeModal.module.scss";

export type Props = {
  onClose: () => void;
};

const StudentLoginQrCodeModal: React.FC<Props> = ({ onClose }) => {
  const loginUrl = `${process.env.REACT_APP_STUDENT_DLP_URL}/st/login`;

  return (
    <Modal
      onClose={onClose}
      centered
      className={styles.studentLoginQrCodeModal}
    >
      <p className={styles.title}>ENAGEEDログイン画面(生徒)</p>
      <div className={styles.urlContainer}>
        <img
          className={styles.qrCodeImage}
          src={qrStudentHomepage}
          alt="qr student homepage"
        />
        <a
          className={styles.url}
          href={loginUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          s.enageed.net
        </a>
      </div>
      <p className={styles.note}>
        生徒がログインID/パスワードを忘れた場合は
        <br />
        以下からご対応ください。
      </p>
      <Link
        className={styles.goToLink}
        to={studentTemporaryPasswordListPath}
        onClick={onClose}
      >
        ログインIDの確認・パスワード再発行へ
      </Link>
    </Modal>
  );
};

export default StudentLoginQrCodeModal;
